import React from "react";
import { useMemo, useState } from "react";
import "./styles.css";
import {
    Grid,
    Typography,
    TextField,
} from "@mui/material";
import Box from '@mui/material/Box';
import Button from "../../components/Button";
import Link from '@mui/material/Link';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { TooltipComp } from "./TooltipComp";
import DialogComp from "../../components/Dialog-Popup";
import { useSignupResponseMutation } from "../../reducer/signupReducer";
import CircularLoader from "../../components/loader";

const initialValues = {
    firstname: "",
    lastname: "",
    email: "",
    phone: "",
    nationalId: "",
    gender: "F",
    password: ""
};


const SignUp = ({ handleClick, handleLogin }) => {
    const [showPassword, setShowPassword] = React.useState(false);
    const [openPopup, setOpenPopup] = useState(false);
    const [stylechange, setstylechange] = useState(false);
    const [popuptitle, SetPopupTitle] = useState("");
    const [errormsg, setErrormsg] = React.useState('')
    const [popupContent, SetPopupContent] = useState("");
    const [buttonArr, setButtonArr] = useState([]);
    const [showPasswordConfirm, setShowPasswordConfirm] = React.useState(false);
    const [values, setValues] = React.useState(initialValues);
    const [errors, setErrors] = React.useState({});
    const handleClickShowPassword = () => setShowPassword((show) => !show);
    const handleClickShowPasswordConfirm = () => setShowPasswordConfirm((showw) => !showw);

    const handleLoginClick = () => {
        handleLogin(true)
    }
    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const handleMouseDownPasswordConfirm = (event) => {
        event.preventDefault();
    };


    function thankuPopup() {
        setOpenPopup(true);
        SetPopupTitle("Thank you!!");
        SetPopupContent(
            ["You’ve done the Sign Up,",
                <br />,
                "Please verify your Email ID by clicking on the link shared to your given mail ID while Sign Up."
            ]
        )
        let btnValues = [
            {
                id: "1",
                value: "Ok",
                color: "borderLess",
                fontfamily: 'Rubik',
                fontSize: "16px",
                functionCall: closeFunc,
            }
        ];
        setButtonArr(btnValues);
    }
    function closeFunc() {
        // setOpenPopup(false);
        handleClick(true)

    }
    const isEmailValid = useMemo(() => {
        var validEmailReg =
            /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
        if (values.email && values.email.match(validEmailReg)) {
            return true;
        } else {
            return false;
        }
    }, [values]);

    const isPasswordValid = useMemo(() => {
        if (values.confirmPassword && values.password && values.confirmPassword === values.password) {
            return true;
        } else {
            return false;
        }
    }, [values]);

    const isMobileNoValid = useMemo(() => {
        var validPhoneReg = /^\d{10}$/;
        if (values.phone && values.phone.match(validPhoneReg)) {
            return true;
        } else {
            return false;
        }
    }, [values]);


    const isPasswordStrong = useMemo(() => {
        if (values.password && values.password.length >= 8 && /[A-Z]+/.test(values.password) && /[a-z]+/.test(values.password) && /[0-9]+/.test(values.password)) {
            return true;
        } else {
            return false;
        }

    }, [values]);

    const validateFields = (event) => {
        event.persist();
        let name = event.target.name;
        let value = event.target.value;
        if (name === 'email' && !isEmailValid) {
            setErrors((errors) => ({ ...errors, [name]: "Please enter valid email ID" }));
        }
        else if (value && name === 'phone' && !isMobileNoValid) {
            setErrors((errors) => ({ ...errors, [name]: "Please enter valid mobile No" }));
        }
        else if (value && name === 'password' && !isPasswordStrong) {
            setErrors((errors) => ({ ...errors, [name]: "Password is not strong enough" }));
        }
        else if (value && name === 'confirmPassword' && !isPasswordValid) {
            setErrors((errors) => ({ ...errors, [name]: "Password and Confirm Password Field do not match " }));
        }
        else if (value === '') {
            setErrors((errors) => ({ ...errors, [name]: "Please enter the value " }));
        }

        else {
            const { [name]: removedProperty, ...errorsRest } = errors;
            setErrors(errorsRest)
        }
    }
    const handleChange = (event) => {
        setErrormsg('')
        event.persist();
        let name = event.target.name;
        let val = event.target.value;
        setValues((values) => ({ ...values, [name]: val }));
        //validateFields(event)
    }

    let disableButton = useMemo(() => {
        if (Object.keys(errors).length === 0 && isEmailValid && isPasswordValid && isPasswordStrong && isMobileNoValid) {
            return false
        }
        else {
            return true
        }
    }, [errors, isPasswordValid, isPasswordStrong, isMobileNoValid, isEmailValid])

    const [
        signupResponse,
        { isLoading, isSuccess, isError, isFetching, error, data: responseData },] = useSignupResponseMutation();


    async function sendSignUpApi() {
        const paramsData = {
            firstname: values.firstname,
            lastname: values.lastname,
            email: values.email,
            phone: "+91" + values.phone,
            nationalId: values.nationalId,
            gender: values.gender,
            userName: values.email,
            password: values.password,
            address:
            {
                "name": "Home",
                "address": "City St",
                "address1": "Cape Town City Centre",
                "address2": "",
                "city": "Cape Town",
                "state": "Cape Province",
                "country": "South Africa",
                "zip": "8000"
            }
        };
        console.log("signup", paramsData);
        // let Id = jobId;
        try {
            const response = await signupResponse({ paramsData });
            if (response.data) {
                console.log('responseinside', response)
                thankuPopup()
            }
            else if (response.error.data.message === "Phone number already exists for some other user.") {
                console.log('insideerror', response.error.data.message)
                setstylechange(true)
                setErrormsg(response.error.data.message)
            }
            else {
                setstylechange(false)
                setErrormsg(response.error.data.message)
            }

        } catch (err) {
            console.log("error", err);
        }
    }


    return (
        <>
        {/* {isLoading && <CircularLoader position="loaderMiddle"></CircularLoader>} */}
        <Box className='signup_container'
            sx={{
                boxShadow: "0px 1px 6px #00000015",
                borderRadius: '9px',
                padding: '6%',
                width: '60%',
                marginTop: '8%',
                background: "#FFFFFF",
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            <Typography sx={{ color: '#000000', letterSpacing: '0.22px', fontWeight: '600', fontSize: '36px', fontfamily: 'Rubik' }} component="h5" variant="h5">
                Sign Up
            </Typography>
            <Typography sx={{ color: '#888888' }} component="h1" >
                Sign Up to get started
            </Typography>
            <Box component="form" noValidate sx={{ mt: 3 }}>
                <Grid style={{ display: 'flex' }} >
                    <div>
                        <label htmlFor="name" style={{ fontFamily: 'Rubik', color: '#000000', fontWeight: 'normal', fontSize: '14px' }}>
                            First name
                        </label>
                        <TextField
                            required
                            fullWidth
                            value={values.firstname}

                            onChange={handleChange}
                            placeholder='Enter first name'
                            style={{ fontFamily: 'Rubik', paddingBottom: '12%', marginTop: '4px', fontSize: '14px' }}
                            name="firstname"
                            onBlur={validateFields}
                            error={errors.firstname !== ""}
                            helperText={errors.firstname !== "" ? errors.firstname : ' '}
                        />
                    </div>
                    <div style={{ marginLeft: '2%' }}>
                        <label htmlFor="name" style={{ fontFamily: 'Rubik', color: '#000000', fontWeight: 'normal', fontSize: '14px' }}>
                            Last name
                        </label>
                        <TextField
                            required
                            fullWidth
                            value={values.lastname}
                            onChange={handleChange}
                            placeholder='Enter last name'
                            style={{ fontFamily: 'Rubik', paddingBottom: '12%', fontSize: '14px', marginTop: '4px' }}
                            name="lastname"
                            onBlur={validateFields}
                            error={errors.lastname !== ""}
                            helperText={errors.lastname !== "" ? errors.lastname : ' '}
                        />
                    </div>
                </Grid>
                <label htmlFor="name" style={{ fontFamily: 'Rubik', color: '#000000', fontWeight: 'normal', fontSize: '14px' }}>
                    Email ID
                </label>
                <TextField
                    required
                    placeholder='Enter Email ID'
                    fullWidth
                    value={values.email}
                    onChange={handleChange}
                    style={{ fontFamily: 'Rubik', paddingBottom: '10%', marginTop: '4px', fontSize: '14px' }}
                    name="email"
                    onBlur={validateFields}
                    error={errors.email !== ""}
                    helperText={errors.email !== "" ? errors.email : ' '}
                />
                <label htmlFor="name" style={{ fontFamily: 'Rubik', color: '#000000', fontWeight: 'normal', fontSize: '14px' }}>
                    Mobile Number
                </label>
                <TextField
                    required
                    placeholder='Enter your mobile number'
                    fullWidth
                    onChange={handleChange}
                    value={values.phone}
                    name="phone"
                    inputProps={{
                        maxLength: 10,
                    }}
                    style={{ fontFamily: 'Rubik', paddingBottom: '10%', marginTop: '4px', fontSize: '14px' }}
                    onBlur={validateFields}
                    error={errors.phone !== ""}
                    helperText={errors.phone !== "" ? errors.phone : ' '}
                />
                <label htmlFor="name" style={{ fontFamily: 'Rubik', color: '#000000', fontWeight: 'normal', fontSize: '14px' }}>
                    Your National ID
                </label>
                <TextField
                    required
                    placeholder='Enter your national ID'
                    fullWidth
                    onChange={handleChange}
                    value={values.nationalId}
                    id="password"
                    style={{ fontFamily: 'Rubik', paddingBottom: '10%', marginTop: '4px', fontSize: '14px' }}
                    name="nationalId"
                    onBlur={validateFields}
                    error={errors.nationalId !== ""}
                    helperText={errors.nationalId !== "" ? errors.nationalId : ' '}
                // autoComplete="email"

                />
                {/* <FormControl> */}
                <FormLabel sx={{ color: '#000000', fontFamily: 'Rubik', fontSize: '14px' }}>Select Your Gender</FormLabel>
                <RadioGroup
                    row
                    aria-labelledby="demo-radio-buttons-group-label"
                    defaultValue={values.gender}
                    name="gender"

                >
                    <FormControlLabel value="M" control={<Radio
                        sx={{
                            '&, &.Mui-checked': {
                                color: '#0D5C75',
                            },
                            fontFamily: 'Rubik'
                        }}

                    />} label="Male" />
                    <FormControlLabel value="F" control={<Radio sx={{
                        '&, &.Mui-checked': {
                            color: '#0D5C75',
                        },
                        fontFamily: 'Rubik'
                    }} />} label="Female" />
                    <FormControlLabel value="O" control={<Radio
                        sx={{
                            '&, &.Mui-checked': {
                                color: '#0D5C75',
                            },
                            fontFamily: 'Rubik'
                        }} />} label="Other" />
                </RadioGroup>
                {/* </FormControl> */}
                <div style={{ marginTop: '3%', width: '100%' }}>
                    <label htmlFor="name" style={{ fontFamily: 'Rubik', color: '#000000', fontSize: '14px', fontWeight: 'normal' }}>
                        Password
                    </label>
                    <div style={{ display: 'flex', marginRight: '-26px' }}>
                        <TextField
                            sx={{ width: '100%', marginTop: '4px', fontSize: '14px' }}
                            placeholder='Enter your Password'
                            name="password"
                            onChange={handleChange}
                            value={values.password}
                            onBlur={validateFields}
                            error={errors.password !== ""}
                            helperText={errors.password !== "" ? errors.password : ' '}
                            type={showPassword ? 'text' : 'password'}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={handleClickShowPassword}
                                            onMouseDown={handleMouseDownPassword}
                                            edge="end"
                                            style={{ color: '#0D5C75' }}
                                        >
                                            {showPassword ? <Visibility /> : <VisibilityOff />}
                                        </IconButton>
                                    </InputAdornment>
                                )
                            }}
                        />
                        <TooltipComp values={values} />
                    </div>
                </div>
                <div style={{ marginTop: '8%', width: '100%' }}>
                    <label htmlFor="name" style={{ fontFamily: 'Rubik', color: '#000000', fontSize: '14px', fontWeight: 'normal' }}>
                        Confirm Password
                    </label>
                    <div style={{ display: 'flex' }}>
                        <TextField
                            sx={{ width: '100%', marginTop: '4px', fontSize: '14px' }}
                            name="confirmPassword"
                            onBlur={validateFields}
                            error={errors.confirmPassword !== ""}
                            helperText={errors.confirmPassword !== "" ? errors.confirmPassword : ' '}
                            onChange={handleChange}
                            placeholder=' Confirm Password'
                            type={showPasswordConfirm ? 'text' : 'password'}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={handleClickShowPasswordConfirm}
                                            onMouseDown={handleMouseDownPasswordConfirm}
                                            edge="end"
                                            style={{ color: '#0D5C75' }}
                                        >
                                            {showPasswordConfirm ? <Visibility /> : <VisibilityOff />}
                                        </IconButton>
                                    </InputAdornment>
                                )
                            }}
                        />
                    </div>
                </div>

                <Grid style={{ display: 'flex', flexDirection: 'column', marginTop: '10%' }}>
                    {stylechange ? (
                        <Typography style={{ marginLeft: '11%', color: 'red', fontSize: '13px' }}>{errormsg}</Typography>

                    ) : (
                        <Typography style={{ marginLeft: '29%', color: 'red', fontSize: '13px' }}>{errormsg}</Typography>

                    )}
                    <div style={{ display: 'flex', justifyContent: 'center', marginTop: '1%' }}>

                        <Button
                            opacity="1"
                            name="Sign Up"
                            color={disableButton ? "grey" : " green"}
                            disabled={disableButton}
                            // onClick={event => handleClick(true)}
                            onClick={sendSignUpApi}
                        />
                    </div>
                </Grid>
                <Grid style={{ marginLeft: '20%', marginTop: '11%', display: 'flex', }}>
                    <Typography sx={{ fontfamily: 'Rubik' }}>
                        Already a user?
                    </Typography>&nbsp;
                    <a href="#" onClick={event => handleClick(true)} style={{ color: '#0D5C75', fontSize: '18px', fontfamily: 'Rubik', fontWeight: 'bold',textDecoration:'underline 1px solid #0D5C75' }}>
                        Click here
                    </a>

                </Grid>
                <DialogComp
                    openPopup={openPopup}
                    popuptitle={popuptitle}
                    popupContent={popupContent}
                    buttonValue={buttonArr}
                />
            </Box>
        </Box>
        </>
    )
}

export default SignUp;
